let label;
let language = localStorage.getItem("PCMSClientLanguage");
if (language === "En") {
  label = {
    test: "test",
  };
} else if (language === "Fr") {
  label = {
    test: "test",
  };
} else if (language === "Ar") {
  label = {
    test: "test",
  };
} else if (language === "Tr") {
  label = {
    test: "test",
  };
} else {
  label = {
    page: {
      honor: "افتخارات ما",
      team: "تیم و همکاران ما",
      blog: "مقالات",
      resume: "ارسال رزومه",
      branch: "درخواست اخذ نمایندگی",
      gallery: "گالری چندرسانه‌ای",
      imageGallery: "گالری تصویر",
      videoGallery: "گالری ویدئو",
      soundGallery: "گالری صوت",
      product: "محصولات",
      education: "آموزش",
      login: "ورود به پنل کاربری",
      register: "عضویت در سامانه",
      forgotPass: "فراموشی رمز عبور",
      editProfile: "ویرایش پروفایل کاربری",
      editAvatar: "ویرایش تصویر پروفایل",
      editPassword: "ویرایش رمز عبور",
    },
    menu: {
      home: "صفحه اصلی",
      login: "ورود",
      register: "عضویت",
      panel: "پنل کاربری",
      langFa: "فارسی (Fa)",
      langEn: "انگلیسی (En)",
      langFr: "فرانسوی (Fr)",
      langAr: "عربی (Ar)",
      langTr: "ترکی استانبولی (Tr)",
    },
    button: {
      login: "ورود به میز کاربری",
      home: "صفحه اصلی",
      back: "بازگشت",
      newsletter: "ثبت عضویت",
      search: "جستجو",
      show: "مشاهده",
      showMore: "مشاهده موارد بیشتر",
      showAttach: "مشاهده پیوست",
      showProduct: "مشاهده محصول",
      readMore: "بیشتر بخوانید",
      downloadAttach: "دریافت پیوست",
      send: "ارسال",
      sendMessage: "ارسال پیام",
      sendResume: "ارسال رزومه",
      answer: "پاسخ",
      closeModal: "بستن پنجره",
      showRestBlog: "مشاهده سایر مقالات",
      moreInformation: "اطلاعات بیشتر",
      downloadAttachment: "دانلود پیوست",
      deleteAvatar: "حذف تصویر پروفایل",
      cancel: "انصراف",
      deleteConfirm: "بله، حذف شود",
      cancellation: "بله، ابطال شود",
      panel: "ورود به پنل",
    },
    form: {
      mandatory: "الزامی",
      optional: "اختیاری",
      username: "نام کاربری",
      currentPassword: "رمز عبور فعلی",
      newPassword: "رمز عبور جدید",
      password: "رمز عبور",
      repeatPassword: "تکرار رمز عبور",
      emailOrMobile: "شماره همراه یا پست الکترونیک",
      searchHolder: "عنوان مورد نظر ...",
      categorySearchHolder: "جستجو دسته بندی ...",
      firstName: "نام",
      lastName: "نام خانوادگی",
      fullName: "نام و نام خانوادگی",
      email: "پست الکترونیک شما",
      mobile: "تلفن همراه",
      phone: "تلفن ثابت",
      address: "آدرس پستی",
      zipCode: "کد پستی",
      nationalCode: "کد ملی",
      nationalId: "شناسه ملی",
      certificateNumber: "شماره شناسنامه",
      tel: "شماره تماس",
      subject: "موضوع",
      message: "متن پیام",
      content: "متن و محتوا",
      comment: "نظر شما",
      commentHolder: "نظر و یا پیشنهاد خود را بنویسید",
      activityField: "زمینه فعالیت",
      description: "توضیحات تکمیلی",
      uploadResume: "بارگذاری فایل رزومه (PDF)",
      company: "نام شرکت",
      companyName: "نام شرکت، مؤسسه و...",
      memberCount: "تعداد اعضا",
      introductionMethod: "نحوه آشنایی",
      city: "استان",
      state: "شهر",
      area: "منطقه",
      chooseCity: "ابتدا استان را انتخاب کنید",
      experience: "سابقه کار (تجربه)",
      attachment: "فایل پیوست",
      OTPCode: "کد احراز هویت",
    },
    caption: {
      homeServices: "همراه با انجمن صنفی حسابدارن قم",
      homeServicesText:
        "سیستم یکپارچه پارسینا مجموعه مهمترین ماژولهای مدیریت شامل حسابداری مالی و خزانه، انبار و کنترل موجودی، خرید فروش و بازرگانی و ...",
      homeProducts: "محصولات انجمن صنفی حسابداران قم",
      homeProductsText:
        "سیستم یکپارچه پارسینا مجموعه مهمترین ماژولهای مدیریت شامل حسابداری مالی و خزانه، انبار و کنترل موجودی، خرید فروش و بازرگانی و ...",
      homeVideo: "انجمن صنفی حسابداران در یک نگاه",
      homeBlog: "اخبار و مقالات",
      homeBlogText:
        "سیستم یکپارچه پارسینا مجموعه مهمترین ماژولهای مدیریت شامل حسابداری مالی و خزانه، انبار و کنترل موجودی، خرید فروش و بازرگانی و ...",
      homeCustomers: "سازمان‌ها و شرکت‌هایی که ما را انتخاب کرده اند",
      homeTestimonial: "رضایت مشتریان، دلیل کیفیت خدمات",
      homeTestimonialText: "رضایتنامه برخی از مشتریان",
      beFirst: "اولین باش",
      newsletter:
        "با عضویت در خبرنامه، شما میتوانید از آخرین نرم افزارها و محصولات ما مطلع شوید.",
      chooseLang: "زبان سایت را انتخاب کنید:",
      loadingTxt: "از صبر و شکیبایی شما سپاسگزاریم",
      honor: "برخی از دستاورد های ما",
      filterByCategory: "فیلتر بر اساس دسته بندی",
      filterByGallery: "فیلتر بر اساس گالری",
      publishDate: "تاریخ انتشار",
      lastUpdate: "آخرین بروزرسانی",
      category: "دسته‌بندی",
      tags: "برچسب‌ها",
      tag: "برچسب‌",
      comments: "نظرات",
      comment: "نظر",
      sendComment: "ارسال نظر",
      answerComment: "پاسخ نظر",
      relatedBlog: "مقالات مرتبط",
      relatedBlogTxt: "آخرین مقالات و اخبار مقالات مرتبط",
      tel: "شماره تماس",
      email: "پست الکترونیک",
      address: "آدرس",
      zipCode: "کد پستی",
      map: "نقشه",
      followUs: "ما را در فضای مجازی دنبال کنید",
      resume:
        "در صورتی که مایل به همکاری با ما هستید، با تکمیل فرم زیر ما را در جریان قرار دهید.        پس از بررسی کارشناسان و در صورت واجد شرایط بودن با شما تماس گرفته خواهد شد.",
      branch:
        "در صورتی که مایل به همکاری با ما و فروش محصولات ما هستید، فرم زیر را به صورت دقیق پر کرده و برای ما ارسال کنید. تا در اسرع وقت کارشناسان ما با شما تماس بگیرند.",
      demo: "درخواست دمو",
      demoTxt: "درخواست خود را ثبت کنید تا در اسرع وقت با شما تماس گرفته شود",
      deleteConfirm: "آیا از حذف این مورد مطمئن هستید ؟",
      cancellation: "آیا از ابطال این مورد مطمئن هستید ؟",
    },
    popup: {
      language: "تغییر زبان",
    },
  };
}

export default label;
